import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05f09fc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "is-flex is-flex-direction-row is-align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_4 = {
  key: 0,
  class: "is-flex is-flex-direction-row is-align-items-center mt-3"
}
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = {
  key: 1,
  class: "is-flex is-flex-direction-row is-align-items-center mt-3"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "None specified", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "ml-2" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-pen" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1 desktopLabel" }, "Edit", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-1 desktopLabel" }, "Delete", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]


export default /*#__PURE__*/_defineComponent({
  __name: 'ListEditor',
  props: {
    items: null,
    fixedItemLabel: null,
    headerLabel: null,
    itemIcon: null,
    itemLabel: null,
    addLabel: null,
    onAdd: null,
    onEdit: null,
    onRemove: null
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_SaveButton = _resolveComponent("SaveButton")!
  const _component_Columns = _resolveComponent("Columns")!

  return (_openBlock(), _createBlock(_component_Columns, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.headerLabel)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(__props.headerLabel), 1))
            : _createCommentVNode("", true),
          (__props.onAdd)
            ? (_openBlock(), _createBlock(_component_SaveButton, {
                key: 1,
                class: "has-text-left",
                label: __props.addLabel,
                icon: "fa-plus",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.onAdd()))
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        (__props.fixedItemLabel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("i", {
                class: _normalizeClass(["fa", __props.itemIcon])
              }, null, 2),
              _createElementVNode("div", _hoisted_5, _toDisplayString(__props.fixedItemLabel), 1)
            ]))
          : _createCommentVNode("", true),
        (!__props.fixedItemLabel && __props.items.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "is-flex is-flex-direction-row is-align-items-center mt-3",
            key: idx
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["fa", __props.itemIcon])
            }, null, 2),
            _createElementVNode("div", _hoisted_9, _toDisplayString(__props.itemLabel(item)), 1),
            (__props.onEdit)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "ml-5",
                  onClick: ($event: any) => (__props.onEdit(idx))
                }, _hoisted_13, 8, _hoisted_10))
              : _createCommentVNode("", true),
            (__props.onRemove)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "ml-5",
                  onClick: ($event: any) => (__props.onRemove(idx))
                }, _hoisted_17, 8, _hoisted_14))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})